<template>
    <div class="">
        <b-container fluid>
            <h1>Salary Recommendation Report</h1>

            <b-row>
                <b-col cols="12" lg="4">
                  <BaseClassificationSelector v-model="criteria.finalClassification"
                            :v="$v.criteria.finalClassification"
                            slug="classification"
                            label="Final Classification"
                            sr="Search for Final Classification"/>
                </b-col>
            </b-row>

            <hr/>
          
              <b-row class="mb-3">
                <b-col>
                  <b-button type="button" variant="primary" @click="search">
                      <b-spinner small v-show="loading" class="mr-2"></b-spinner>Search</b-button>
                  <b-button variant="outline-primary" @click="download" class="ml-5">
                      <b-spinner small v-show="loadingDownload" class="mr-2"></b-spinner>
                      Download Spreadsheet
                  </b-button>
                </b-col>

                <b-col cols="12" lg="6" class="my-1">
                  <b-form-group
                      label="Filter"
                      label-cols-sm="3"
                      label-align-sm="right"
                      label-size="sm"
                      label-for="filterInput"
                      class="mb-0">
                    <b-input-group size="sm">
                      <b-form-input
                          v-model="filter"
                          type="search"
                          id="filterInput"
                          placeholder="Type to Search"></b-form-input>
                      <b-input-group-append>
                        <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col>
              </b-row>
            
              <b-row>
                <b-col>
                  <b-table hover small responsive show-empty
                    :fields="fields"
                    :items="requests"
                    :filter="filter"
                    :busy="loading">
                    <template v-slot:no-data>
                      <v-btn color="primary" @click="initialize">Reset</v-btn>
                    </template>
                    <template #table-caption></template>
                    <template v-slot:empty="scope">
                      <p>No requests found.</p>
                    </template>

                    <div slot="table-busy" class="text-center text-danger my-2">
                        <b-spinner class="align-middle" style="margin-right:5px; margin-top:12px;"></b-spinner>
                        <strong>Loading, Please Wait...</strong>
                    </div>        

                  </b-table>
                </b-col>
              </b-row>
          </b-container>
      </div>
</template>

<script>
import axios from "axios"
import { required, email, minLength, maxLength, numeric, requiredUnless, requiredIf, ref, minValue, maxValue } from 'vuelidate/lib/validators'
import fileDownload  from 'js-file-download'
import { commonOptions } from '@/mixins/commonOptions.js'
import pageTitle from '@/mixins/pageTitle'

export default {
  title: 'Salary Recommendation Report',
  data: () => ({
    loading: false, 
    loadingDownload: false,
    loaded: false,

    filter: null,

    criteria: {
      finalClassification: null,
    },
    requests: [],
    fields: [
        {key: 'mdhTrackingId', sortable: true, label: 'Number'},
        {key: 'division', sortable: true, label: 'Division'},
        {key: 'employeeName', sortable: true, label: 'Employee Name'},
        {key: 'startDate', sortable: true, label: 'Start Date'},
        {key: 'hireType', sortable: true, label: 'Hire Type'},
        {key: 'approvedStep', sortable: true, label: 'Step'},
        {key: 'payRate', sortable: true, label: 'Rate'},
        {key: 'educationLevel', sortable: true, label: 'Education Level'},
        {key: 'yearsOfRelatedExp', sortable: true, label: 'Years of Related Experience'},
        {key: 'specialSkills', sortable: true, label: 'Special Skills'},
      ],
  }),
  components: {
  },
  mixins: [
    commonOptions,
    pageTitle
  ],
  validations: {
    criteria: {
      finalClassification: { required: false },
    }
  },
  mounted () {
  },
  computed: {
  },
  methods: {
    search() {
          this.loading = true
          this.loaded = false
          this.requests = []
          axios.post(`${process.env.VUE_APP_API_BASE_URL}/report/salary`, this.criteria)
          .then(response => { 
            this.requests = response.data
            this.loaded = true
            this.loading = false
          })
    },
    download() {
      this.loadingDownload = true
      let requestConfig = {
        responseType: 'blob'       
      }
      
      axios.post(`${process.env.VUE_APP_API_BASE_URL}/export/salary`, this.criteria, requestConfig)
      .then(response => { 
        this.loadingDownload = false
        fileDownload(response.data, 'salary-recommendations.xlsx')
      })
    },
  }
 }
</script>

<style>

</style>